module.exports = "/templates/bds/public/images/7640146c80040eeb1feb3dd223fc591d.png";